module.exports = __webpack_public_path__ + "static/img/notebook.1d3cf44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notebook.png
// module id = soRz
// module chunks = 0